import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 my-4 max-w-sm mx-auto bg-gray-200 dark:bg-gray-700 rounded-xl shadow-md flex items-center space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.searchLink,
      class: "flex flex-row items-center flex-auto text-lg font-medium w-full"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", { class: "flex-1" })
      ]),
      _: 3
    }, 8, ["to"]),
    _createElementVNode("button", {
      "aria-label": "Marcar búsqueda reciente como favorita",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        title: "Buscar",
        class: "fill-current text-yellow-400",
        icon: [_ctx.recentSearch.faved ? 'fas' : 'far', 'star']
      }, null, 8, ["icon"])
    ])
  ]))
}